<template>
  <form class="">
    <h1 class="is-size-1" style="color: rebeccapurple">
      Welcome to A Lil NANO, the fast and free NANO faucet!
    </h1>
    <br/>
    <h1 class="is-size-2" style="">
      Where should we send the NANO?
      <span>&nbsp;</span>
      <b-tooltip label="Make a NANO wallet" animated> <!-- this is probably where the overflow problem is -->
        <a href="https://nano.org/en/wallet/" target="_blank">
        <span class="icon has-text-info is-small">
          <i class="fas fa-info-circle is-small"></i>
        </span>
        </a>
      </b-tooltip>
    </h1>

    <div style="height: 1rem"></div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">NANO Address</label>
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <p class="control has-icons-right is-expanded">
            <input class="input is-rounded" :class="{ 'is-success': isAddressValid }" type="text"
                   v-bind:value="value" v-on:input="$emit('input', $event.target.value)"
                   placeholder="Looks like 'xrb_1abcd...' or 'nano_1abcd...'">
            <span v-if="isAddressValid" class="icon is-right has-text-success">
              <i class="fas fa-check"></i>
            </span>
          </p>
          <p>
            <button type="button" :disabled="isForgetMeDisabled" class="button is-rounded is-danger" @click="forgetMeClicked">
              Forget Me
            </button>
          </p>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
  import Util from '../lib/Util'

  export default {
    name: "CreateRecipient",
    props: [
      'value'
    ],
    methods: {
      forgetMeClicked() {
        this.$emit('input', '')
        localStorage.removeItem('recipientAddress')
      },
    },
    computed: {
      isAddressValid() {
        return Util.isAddressValid({ address: this.value })
      },
      isForgetMeDisabled() {
        return !this.hasSavedAddress
      },
      hasSavedAddress() {
        return this.value && !!localStorage.getItem('recipientAddress')
      }
    }
  }
</script>

<style scoped>

</style>
